// components/OurClients/OurClients.jsx
import React from "react";
import "./OurClients.css";
import shopaz from "../../assets/images/shopaz.png";
import procredit from "../../assets/images/procredit.png";
import Hib from "../../assets/images/HIB.png";
import burgerking from "../../assets/images/burgerking.png";
import neptun from "../../assets/images/neptun.png";
import trimed from "../../assets/images/trimed.png";
import elka from "../../assets/images/elka.png";
import vfs from "../../assets/images/vfs-min.png";
import prmall from "../../assets/images/prishtina-mall.svg";
import rugove from "../../assets/images/rugove.png";
import ltb from "../../assets/images/ltb.png";
import megatek from "../../assets/images/megatek.png";

const OurClients = () => {
  const clients = [
    { id: 1, name: "SHOPAZ", logo: shopaz },
    { id: 2, name: "PRODCREDIT", logo: procredit },
    { id: 3, name: "HIB", logo: Hib },
    { id: 4, name: "BURGER KING", logo: burgerking },
    { id: 5, name: "NEPTUN", logo: neptun },
    { id: 6, name: "TRIMED", logo: trimed },
    { id: 7, name: "ELKA", logo: elka },
    { id: 8, name: "VIVA FRESH STORE", logo: vfs },
    { id: 9, name: "PRISHTINA MALL", logo: prmall },
    { id: 10, name: "RUGOVE", logo: rugove },
    { id: 11, name: "LTB", logo: ltb },
    { id: 12, name: "MEGATEK", logo: megatek },
  ];

  return (
    <section id="clients" className="clients-section">
      <div className="clients-container">
        <div className="section-header">
          <h2 className="section-title font-heading">
            Trusted By{" "}
            <span className="section-title-highlight">Industry Leaders</span>
          </h2>
          <p className="section-subtitle font-body">
            We've had the privilege to work with some of the most innovative
            companies worldwide
          </p>
        </div>

        <div className="clients-grid">
          {clients.map((client) => (
            <div key={client.id} className="client-card">
              <div className="client-logo-container">
                {/* Replace with actual image import */}
                <img
                  src={client.logo}
                  alt={client.name}
                  className="client-logo"
                  // loading="lazy"
                />
                {/* <div className="client-overlay">
                  <span className="client-name">{client.name}</span>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurClients;
